import { Box, TableCell, TableRow, Tooltip } from '@mui/material';
import { ProjectMenu } from 'src/components/ProjectMenu/ProjectMenu';
import dayjs from 'dayjs';
import { GetProjectResponseProject } from "src/model/api/v2/data-contracts";
import { ProjectListLabelsCell } from "src/pages/ProjectsPage/ProjectListLabelsCell";
import { ElectricalCabinetIcon } from "src/icons/quote/ElectricalCabinetIcon";
import { IsElectricalCabinetAvailable } from "src/pages/ProjectsPage/electricalCabinetAvailable";
import { ts } from "src/utils/translate";
import { getRelativeTime } from "src/utils/timeHelper";
import { theme } from "src/theme/mui-theme";
import { useNavigate } from "react-router";

type Props = {
    extendedProject: GetProjectResponseProject;
};

export default function ProjectsListCellView({ extendedProject }: Props) {
    const navigate = useNavigate();

    return (
        <TableRow
            key={extendedProject.project.id}
            onClick={() => navigate(`/planner/${extendedProject.project.id}`)}
            sx={{ cursor: 'pointer' }}
        >
            <TableCell sx={{ width: '25%' }}>{extendedProject.project.project_name}</TableCell>
            <TableCell sx={{ width: '25%' }}>{extendedProject.project.city} {extendedProject.project.street_address}</TableCell>
            <ProjectListLabelsCell labels={extendedProject.labels} />
            <TableCell sx={{ width: '15%' }}>
                {dayjs(extendedProject.project.created_at).format('YYYY. MM. DD.')}
            </TableCell>
            <TableCell sx={{ width: '15%' }}>
                {getRelativeTime(extendedProject.project.updated_at)}
            </TableCell>
            <TableCell onClick={(e) => e.stopPropagation()}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <Box sx={{ width: 28, height: 28 }}>
                        {IsElectricalCabinetAvailable(extendedProject) && (
                            <Tooltip title={ts('electrical_cabinet_purchased', 'Electrical cabinet purchased')} placement="top">
                                <Box
                                    sx={{
                                        width: 28,
                                        height: 28,
                                        borderRadius: '50%',
                                        backgroundColor: theme.palette.primary.main,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <ElectricalCabinetIcon sx={{ fontSize: 20 }} />
                                </Box>
                            </Tooltip>
                        )}
                    </Box>
                    <ProjectMenu extendedProject={extendedProject}/>
                </Box>
            </TableCell>
        </TableRow>
    );
}
